import { ApiError, parseApiRetryAfterSeconds } from "../lib/apiError";

export { ApiError };

/**
 * Single data-fetch layer for the Go backend (/api/v1) — every dashboard
 * query goes through here so error envelopes are handled once.
 */
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api/v1${path}`, init);
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const envelope = (
      body as { error?: { message?: string; code?: string; details?: unknown } } | null
    )?.error;
    const message = envelope?.message ?? envelope?.code ?? `Request failed (${response.status})`;
    // Retry-After is the server's own instruction for a 429/503; carrying it on
    // the error keeps the waiting policy out of every call site.
    const retryAfter = response.headers.get("Retry-After");
    const requestId = response.headers.get("X-Request-ID")?.trim() || null;
    throw new ApiError(
      message,
      response.status,
      envelope?.code ?? null,
      envelope?.details ?? null,
      parseApiRetryAfterSeconds(retryAfter),
      requestId,
    );
  }
  return body as T;
}
